module.exports = __webpack_public_path__ + "static/media/monsterBorder.9652ae9a.png";